import React from 'react';
import MyCarousel from "../MyCarousel";
import {useNavigate} from "react-router-dom";

const Home = () => {
    const images = [
        './slideshow1/1.jpg',
        './slideshow1/2.jpg',
        './slideshow1/3.png',
        './slideshow1/4.jpg',
        './slideshow1/5.png',
        './slideshow1/6.jpg',
        './slideshow1/7.png',
        './slideshow1/8.jpg',
    ];
    const navigate = useNavigate();
    const handleNavigation = (path) => {
        navigate(path);
        window.scrollTo(0, 0);  // Scrolls to the top of the page
    };

    const scrollToAboutMe = () => {
        document.getElementById('aboutMe').scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <>
            <div className="equestrian-container">
                <div className="text-container">
                    <h1>Ainsley Davis</h1>
                    <h2 className="class-year">Class of 2026</h2>
                    <div className="buttons">
                        <button className="about-button" onClick={scrollToAboutMe}>About Me</button>
                        <button className="history-button" onClick={() => handleNavigation('/bio')}>Bio</button>
                    </div>
                </div>
                <div className="image-container">
                    <MyCarousel images={images}/>
                    {/*<img src="./main.jpg" alt="Equestrian"/>*/}
                </div>
            </div>
            <div className="equestrian-container">
                <div className="image-container">
                    <img src="./pic2.jpg" alt="Ainsley Davis on Pretzel"/>
                </div>
                <div className="text-container">
                    <div className="additional-text">

                        <div className="section-tittle">Jumping Seat Candidate</div>
                        <h4>
                            Riding and being around horses has always been an integral part of my life. I grew up on a horse
                            ranch in Northern California and I have been riding since before I could talk. The beginning of my
                            competitive horse show career started in February of 2022, when we bought my first show horse
                            “Bellarabi”. September of 2022, I started my time at The Ethel Walker school which was a turning
                            point in my riding. During my freshman year with the help of the trainers at Ethel Walker, Linda
                            Langmier, and Kelianda Farm I went from the 2’9ft to the 3’3ft Junior Hunters. My first time in the
                            Junior Hunters I got top three placings at the Wellington Equestrian Festival. I also went from the
                            .80 jumpers to the meters and earned multiple first-place finishes my freshman year on my newly
                            leased jumper “Pretzel”. I joined Ethel Walker’s IEA team in 2022 and qualified for IEA Regional
                            Finals on the flat and over fences in three shows. Since 2022 my riding has grown exponentially,
                            benefitting from riding countless Ethel Walker lesson horses as well as IEA horses at the shows I
                            attended. Ethel Walker has afforded me varied experiences with riding as well as strengthened my
                            horsemanship skills.
                            <br/>
                            Now as a junior I have successfully done many 3’6ft and 3’3ft equitation classes at several
                            competitive venues with top placings and wins in the 1.10s/1.15s Classics including shows at Old
                            Salem, Saratoga, Desert International Horse Park, and WEF. As I continue on my path at Ethel Walker
                            with the guidance of many talented people and professionals I feel confident in my ability to
                            maintain my steadfast progress with riding.
                            <br/>
                            I am currently a Junior at the Ethel Walker School in Simsbury, CT and I am a High Honors student as
                            well as a scholar athlete. I am enrolled in six advanced courses for my junior year and last year
                            finished the semester with a 4.21 GPA. I dedicate every morning before school and after school to
                            riding whilst prioritizing my academics. Finding a balance between school and riding requires
                            organization, time management, clarity of purpose, and a hierarchy of necessary tasks on any given
                            day. Ethel Walker offers endless riding opportunities and academic opportunities engaging me both
                            physically and intellectually, cultivating an environment where I can achieve being a top student
                            while also achieving my riding goals. I actively participate in riding programs but I also have been
                            selected to be a peer tutor, writing fellow (writing tour), and a cicerone who gives tours of the
                            campus, connects with people interested in the school, and helps admissions every week.
                            <br/>
                            My riding journey has taken twists and turns ultimately leading me to Ethel Walker and hopefully
                            will lead to an opportunity to ride for a collegiate equestrian team. Securing a spot on a
                            collegiate team would be the apogee of my years of hard work. Competing in college would allow me to
                            grow as an equestrian, a rider, and a student. Being a team member, supporting my teammates, and
                            representing my college would be an honor.
                        </h4>
                        <div className="single-button-container">
                            <button className="centered-button" onClick={() => handleNavigation('/resume')}>My resume
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="floating-container">
                <h2 className="floating-title" id="aboutMe">In High School</h2>
                <p className="floating-text">
                    There was never a time I wasn't looking forward to my next lesson or ride. Every day after
                    school,
                    including pre-school, I would come home and it was immediately barn time. I found more
                    comfort
                    sitting on a horse's back than anything else and my love for horses only grew as I did. I
                    learned
                    the importance of patience, passion, resilience, focus, and having a work ethic early in my
                    riding
                    career. Having horses in my life has allowed me to bond and grow with them but also has led
                    me
                    to
                    other horse enthusiasts, incredible friends, and ultimately riding teams. Sharing my passion
                    for
                    riding with my peers and cheering them on gives me purpose and enjoyment. There is nothing
                    more
                    rewarding than watching a teammate get a challenging horse around a course or hearing my
                    friends
                    cheer me on no matter what. I’ve experienced perseverance and hard work paying off which
                    fuels
                    me to
                    try even harder knowing that riding is the work you do and the attention you put into it. I
                    look
                    forward to my college riding years and growing my riding skills and horsemanship as well as
                    meeting
                    people I can count as lifelong friends.
                    <br/><br/>
                    I got "Midnight", who was a 38-year-old rescue, for $500 when I was five years old. Whether
                    it
                    was a
                    rogue pony who had never jumped, a fiery upper-level dressage horse, one who refused to
                    jump, a
                    barely broke 3-year-old, or something that just wanted to take off with me I was happy to
                    swing
                    my
                    leg over the saddle. Sometimes I would fetch my grandma's Quarter Horse "Little Rey" from
                    the
                    field
                    and ride him up to the barn bareback in a halter. I even took "Little Rey" to his first
                    dressage
                    show and earned a blue ribbon. I recently took my jumper to the beach and he got to go
                    swimming
                    for
                    the first time. My love for horses runs deep and I have never questioned horses being a part
                    of
                    my
                    life. I spent years riding ponies who taught me the ropes in jumpers, hunters, equitation,
                    and
                    dressage. Once I grew to 5'8" I had to accept it was time for a horse. In search of my first
                    horse,
                    I traveled across the country to "Thanks A Lot Farm" where they retrained kill pen horses
                    and
                    bought
                    a beautiful, timid three-year-old named "Timmy" who had been dumped by an Amish farmer.
                    Timmy
                    was
                    sensitive and untrusting so I had to slowly earn his trust. After being tossed in the dirt a
                    few
                    times, Timmy & I eventually bonded and I successfully could walk, trot, and canter him
                    without
                    incident. Timmy laid the groundwork for what is necessary to succeed with horses, unwavering
                    patience and perseverance.
                    <br/><br/>
                    ~Ainsley Davis

                </p>
            </div>

        </>
    );
};

export default Home;